import { render, staticRenderFns } from "./OpportunityLogList.vue?vue&type=template&id=7152409c&"
import script from "./OpportunityLogList.vue?vue&type=script&lang=js&"
export * from "./OpportunityLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports